import { c as _c } from "react/compiler-runtime";
import { WithChildrenCommonProps } from '@types';
import { Typography } from '@components/typography';
import { getPageStylesAsClassNames } from './page-styles';
export type IPageProps = WithChildrenCommonProps<{
  selected?: boolean;
  disabled?: boolean;
  selectable?: boolean;
  withIcon?: boolean;
  ariaLabel?: string;
  onClick?: () => void;
}>;
export const Page = t0 => {
  const $ = _c(12);
  const {
    children,
    onClick,
    ariaLabel,
    selected: t1,
    disabled: t2,
    selectable: t3,
    withIcon: t4
  } = t0;
  const selected = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  const selectable = t3 === undefined ? true : t3;
  const withIcon = t4 === undefined ? false : t4;
  const t5 = disabled || selected;
  const t6 = selected ? "step" : undefined;
  let t7;
  if ($[0] !== disabled || $[1] !== selectable || $[2] !== selected || $[3] !== withIcon) {
    t7 = getPageStylesAsClassNames({
      selected,
      disabled,
      selectable,
      withIcon
    });
    $[0] = disabled;
    $[1] = selectable;
    $[2] = selected;
    $[3] = withIcon;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== ariaLabel || $[6] !== children || $[7] !== onClick || $[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <Typography bold={true} variant="body2" component="button" onClick={onClick} aria-label={ariaLabel} disabled={t5} aria-current={t6} className={t7}>{children}</Typography>;
    $[5] = ariaLabel;
    $[6] = children;
    $[7] = onClick;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};